import React from 'react';
const AiStaffSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-ai-staff" });
AiStaffSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-ai-staff sirius-icon-ai-staff-enhance" });
export default AiStaffSvg;
